/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Each_Jumpy_Racoon_PropelInputs */

const fr_each_jumpy_racoon_propel = /** @type {(inputs: Each_Jumpy_Racoon_PropelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil utilisateur`)
};

/**

* @param {Each_Jumpy_Racoon_PropelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const each_jumpy_racoon_propel = /** @type {((inputs?: Each_Jumpy_Racoon_PropelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Each_Jumpy_Racoon_PropelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_each_jumpy_racoon_propel(inputs)
});